import { Grid } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

export function actionItem(form_type, valueKey, title, values, devicePrimary, setFieldValue, setRemovedState, deviceLayout) {
    var color = values?.[`devicePrimary-actions-${valueKey}`] ? 'secondary' : 'light';

    return (
        <Grid item xxs={6}>
            <SoftBox display="flex" justifyContent="center" py={3} px={1}
                disabled={valueKey != 'removed' && values['devicePrimary-actions-removed']}
                onClick={(e) => {
                    if (valueKey !== 'removed' && values['devicePrimary-actions-removed']) return;
                    // console.log(e);
                    setFieldValue(devicePrimary.actions[valueKey].name, !values[`devicePrimary-actions-${valueKey}`]);
                    if (valueKey == 'removed') {
                        setRemovedState(!values[`devicePrimary-actions-${valueKey}`]);
                        var actions = ['installed', 'cleaned', 'battery_swap', 'hardware_changed', 'cosmetically_fixed'];
                        if(form_type == 'assignment') actions = actions.filter((row) => row != 'installed');
                        
                        for (var action of actions) {
                            setFieldValue(devicePrimary.actions[action].name, false);
                        }
                    }
                }}
                sx={({ palette: { gradients }, functions: { rgba, linearGradient } }) => {
                    const isDisabled = valueKey !== 'removed' && values['devicePrimary-actions-removed'];
                    return {
                        borderRadius: '10px',
                        border: '1px solid #aaa',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        opacity: isDisabled ? 0.3 : 1,
                        background: linearGradient(rgba(gradients[color].main, 0.6), rgba(gradients[color].state, 0.6))
                    }
                }}
            >
                <SoftBox display="flex" alignItems="center" sx={{ paddingTop: '2.5px' }}>
                    <SoftTypography variant={deviceLayout == "mobile" ? "mobileBody1" : "body2"} fontWeight={deviceLayout == "mobile" ? 'bold' : 'bold'}>{title}</SoftTypography>
                </SoftBox>
            </SoftBox>
        </Grid>
    )
};